import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';

import { foldToAsciiForXeroTrackingInputTrimmed } from '@gh/core-util';

export const XERO_TRACKING_CONTROL_NAMES = new Set<string>([
  'businessName',
  'firstName',
  'lastName',
  'siteName',
  'siteLotNumber',
  'siteStreet',
  'siteStreetNumber',
  'siteSuburb',
  'siteReference',
  'siteAddress',
  'contactName',
  'customerName',
  'owner1',
  'owner2',
  'owner3',
  'name',
  'lotNumber',
  'blockNumber',
  'suburb',
  'streetNumber',
  'street',
  'city',
  'state',
  'postCode',
  'reference',
  'mapReference',
  'housePlanName',
  'jobMemo',
  'salesFolderName',
  'quotationDescription',
]);

export function normalizeXeroTrackingFormControls(root: AbstractControl | null | undefined): void {
  if (!root) {
    return;
  }

  walkControlTree(root, [], (control, path) => {
    const controlName = path[path.length - 1];
    if (!controlName || !XERO_TRACKING_CONTROL_NAMES.has(controlName)) {
      return;
    }

    const value = control.value;
    if (typeof value !== 'string') {
      return;
    }

    const normalized = foldToAsciiForXeroTrackingInputTrimmed(value);
    if (normalized !== value) {
      control.setValue(normalized, { emitEvent: false });
    }
  });
}

function walkControlTree(
  control: AbstractControl,
  path: string[],
  visit: (control: FormControl, path: string[]) => void,
): void {
  if (control instanceof FormGroup) {
    Object.keys(control.controls).forEach((name) =>
      walkControlTree(control.controls[name], [...path, name], visit));
    return;
  }

  if (control instanceof FormArray) {
    control.controls.forEach((child, index) => walkControlTree(child, [...path, String(index)], visit));
    return;
  }

  if (control instanceof FormControl) {
    visit(control, path);
  }
}
